import { EViewMode } from 'reactApp/modules/settings/settings.types';

export const isMobileGalleryViewMode = (viewMode?: EViewMode) => {
    if (!viewMode) {
        return false;
    }
    const mobileGalleryViewModes = [EViewMode.galleryGrid3];
    return mobileGalleryViewModes.includes(viewMode);
};
